import React from 'react'
import {translate} from 'react-i18next'
import InputMask from 'react-input-mask'
import {Input, InputView, ShowPasswordButton, Loading} from './InputStyles'

class InputContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {type: this.props.type}
    this.container = React.createRef()
  }

  componentWillUnmount() {
    if (this.isPassword(this.props.type)) {
      document.removeEventListener('click', this.handleOutsideClick, false)
    }
  }

  onFocus = () => {
    if (this.isPassword(this.props.type)) {
      document.addEventListener('click', this.handleOutsideClick, false)
    }
    this.props.onFocus && this.props.onFocus()
  }

  isPassword = type => type === 'password'

  showPassword = () => {
    if (this.isPassword(this.state.type)) {
      this.setState({type: 'text'})
    } else {
      this.setState({type: this.props.type})
    }
  }

  handleOutsideClick = e => {
    // ignore clicks on the component itself
    const container = this.container.current
    if (container && container.contains(e.target)) {
      return
    }
    if (this.state.type === 'text') {
      this.setState({type: 'password'})
    }
    this.props.onBlur && this.props.onBlur({target: {name: this.props.name}})
  }

  renderInput = () => {
    const {onChange, onBlur, onFocus, type, t, loading, mask, maskPlaceholder, disabled, value, ...props} = this.props
    const isPassword = this.isPassword(type)

    if (mask) {
      /*
        onChange, onMouseDown, onFocus, onBlur, value, disabled, readOnly
        should be defined on the InputMask component itself
       */
      return (
        <InputMask
          {...props}
          mask={mask}
          maskChar={null}
          onChange={onChange}
          value={value}
          disabled={disabled}
          onBlur={isPassword ? undefined : onBlur}
          onFocus={isPassword ? this.onFocus : onFocus}>
          {inputProps => <Input {...inputProps} type={this.state.type} />}
        </InputMask>
      )
    }

    return (
      <Input
        {...props}
        onChange={onChange}
        value={value}
        disabled={disabled}
        onBlur={isPassword ? undefined : onBlur}
        onFocus={isPassword ? this.onFocus : onFocus}
        type={this.state.type}
      />
    )
  }

  render() {
    const {type, t, loading, ...props} = this.props
    const isPassword = this.isPassword(type)
    return (
      <InputView ref={this.container}>
        {this.renderInput()}
        {isPassword && (
          <ShowPasswordButton onClick={this.showPassword}>
            {this.isPassword(this.state.type) ? t('show-password') : t('hide-password')}
          </ShowPasswordButton>
        )}
        {loading && <Loading {...props} />}
      </InputView>
    )
  }
}

export default translate()(InputContainer)
